import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux'
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Divider, Drawer } from '@mui/material';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SettingsIcon from '@mui/icons-material/Settings';
import InputIcon from '@mui/icons-material/Input';
import TuneIcon from '@mui/icons-material/Tune';
import AlarmAddIcon from '@mui/icons-material/AlarmAdd';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import { SearchInput } from '../../../../components/';
import { Hidden, Button, IconButton, List, ListItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { Profile, SidebarNav } from './components';
import useClasses from '../../../../helpers/useClasses';

const styles = theme => ({
  drawer: {
    width: 250,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    },
    overflow: 'scroll',
    backgroundColor: '#17507f'
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '5000px',
    padding: theme.spacing(2),
    backgroundColor: '#17507f'
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  },
  searchInput: {
    flexBasis: 0,
    marginBottom: '15px'
  },
  button: {
    backgroundColor: '#43a047',
    color: '#fff',
    padding: '10px 5px'
  },
  logout: {
    marginTop: 'auto'
  },
  signOutButton: {
    color: '#fff',
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  signOutIcon: {
    color: '#fff',
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  noUnderline: {
    textDecoration: 'none'
  }
});

const Sidebar = props => {
  const { open, variant, onClose, className, onMerchantSearchClick, onLogoutClick, is_admin, is_dm_admin, user, account_merchant_subscription_enabled } = props;

  const classes = useClasses(styles);

  let pages = [
    {
      title: 'Dashboard',
      href: '/dashboard',
      icon: <DashboardIcon />
    },
    {
      title: 'Analytics',
      href: '/analytics',
      icon: <EqualizerIcon />
    },
    {
      title: 'Our Members',
      href: '/members',
      icon: <PeopleIcon />
    },
    {
      title: 'Merchant Subscriptions',
      href: '/merchant_subscriptions',
      icon: <AlarmAddIcon />
    }
  ];
  
  if (is_admin) {
    pages = [
      {
        title: 'Dashboard',
        href: '/dashboard',
        icon: <DashboardIcon />
      },
      {
        title: 'Analytics',
        href: '/analytics',
        icon: <EqualizerIcon />
      },
      {
        title: 'Our Members',
        href: '/members',
        icon: <PeopleIcon />
      },
      {
        title: 'Merchant Subscriptions',
        href: '/merchant_subscriptions',
        icon: <AlarmAddIcon />
      }
    ]
  }

  if (is_admin && user.plan_level === 'PRO') {
    pages = [
      {
        title: 'Dashboard',
        href: '/dashboard',
        icon: <DashboardIcon />
      },
      {
        title: 'Analytics',
        href: '/analytics',
        icon: <EqualizerIcon />
      },
      {
        title: 'Our Members',
        href: '/members',
        icon: <PeopleIcon />
      },
      {
        title: 'Merchant Subscriptions',
        href: '/merchant_subscriptions',
        icon: <AlarmAddIcon />
      }
    ]
  }

  if (!is_admin && user.plan_level === 'PRO') {
    pages = [
      {
        title: 'Dashboard',
        href: '/dashboard',
        icon: <DashboardIcon />
      },
      {
        title: 'Analytics',
        href: '/analytics',
        icon: <EqualizerIcon />
      },
      {
        title: 'Our Members',
        href: '/members',
        icon: <PeopleIcon />
      }
    ]
  }

  if (user.integrator){
    pages = pages.filter(item => item.title !== 'Our Members');
    pages = pages.filter(item => item.title !== 'Analytics');
  }

  let account_pages = [
    {
      title: 'Profile',
      href: '/profile',
      icon: <AccountBoxIcon />
    }
  ]

  if (is_admin && account_merchant_subscription_enabled && user.plan_level === 'PRO') {
    account_pages = [
      {
        title: 'Profile',
        href: '/profile',
        icon: <AccountBoxIcon />
      },
      {
        title: 'Account',
        href: '/account',
        icon: <SettingsIcon />
      }
    ]
  }

  if (is_admin && (!account_merchant_subscription_enabled || user.plan_level != 'PRO')) {
    account_pages = [
      {
        title: 'Profile',
        href: '/profile',
        icon: <AccountBoxIcon />
      },
      {
        title: 'Account',
        href: '/account',
        icon: <SettingsIcon />
      }
    ]
  }

  let admin_pages = [];

  if (is_dm_admin) {
    admin_pages = [
      {
        title: 'Funders',
        href: '/funders',
        icon: <AttachMoneyIcon />
      },
      {
        title: 'Merchants',
        href: '/merchants',
        icon: <ShoppingBasketIcon />
      }
    ]
  }

  let dm_admin_pages = [];

  if (is_dm_admin) {
    dm_admin_pages = [
      {
        title: 'Settings',
        href: '/settings',
        icon: <TuneIcon />
      }
    ]
  }

  let logout_pages = []
  

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
      // sx={{
      //   height: '4000px'
      // }}
    >
      <div
        className={classes.root}
      >
        <Profile />
        <Divider 
          // className={classes.divider}
          sx={{ margin: '16px 0'}}
        />
        
        <SearchInput
          // className={classes.searchInput}
          placeholder="Full EIN/legal name search"
          onSearchClick={onMerchantSearchClick}
          user={user}
          sx={{
            flexBasis: 0,
            marginBottom: '15px'
          }}
        />
        <RouterLink to="/merchants/new"
          // className={classes.noUnderline}
          sx={{
            textDecoration: 'none'
          }}
        >
          <Button
            variant="contained"
            // className={classes.button}
            startIcon={<AddIcon />}
            fullWidth={true}
            sx={{
              backgroundColor: '#43a047',
              color: '#fff',
              padding: '10px 5px',
              marginTop: '15px'
            }}
          >
            Add Merchant
          </Button>
        </RouterLink>
        <Divider
          // className={classes.divider}
          sx={{ margin: '16px 0'}}
        />
        
        <SidebarNav
          // className={classes.nav}
          pages={pages}
          sx={{marginBottom: '16px'}}
        />
        {props.is_admin ? 
          <SidebarNav
            // className={classes.nav}
            sx={{marginBottom: '16px'}}
            pages={admin_pages}
          /> : null }
        <SidebarNav
          // className={classes.nav}
          sx={{marginBottom: '16px'}}
          pages={account_pages}
        />
        
          <Divider></Divider>
          {props.is_dm_admin ? 
          <SidebarNav
            // className={classes.nav}
            pages={dm_admin_pages}
          /> : null }
          <List>
              <ListItem
                // className={classes.item}
                disableGutters
                key='logout'
                sx={{
                  display: 'flex',
                  paddingTop: 0,
                  paddingBottom: 0
                }}
              >
                <Button
                  className={classes.signOutButton}
                  sx={{
                    color: '#fff',
                    padding: '10px 8px',
                    justifyContent: 'flex-start',
                    textTransform: 'none',
                    letterSpacing: 0,
                    width: '100%',
                    fontWeight: 'medium',
                    cursor: 'pointer'
                  }}
                  onClick={onLogoutClick}
                >
                    <InputIcon sx={{
                      position: 'relative',
                      display: 'flex',
                      marginRight: '10px'
                    }} />
                  <span>Logout</span>
                </Button>
              </ListItem>
          </List>
          <SidebarNav
            // className={classes.nav}
            sx={{marginBottom: '16px'}}
            pages={[]}
          />
        </div>
      
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

const mapStateToProps = state => {
  return {
    is_admin: state.auth.user.is_admin,
    is_dm_admin: state.auth.user.is_dm_admin,
    account_merchant_subscription_enabled: state.auth.user.account_merchant_subscription_enabled,
    user: state.auth.user
  }
}

export default connect(mapStateToProps, null)(Sidebar)